import { render, staticRenderFns } from "./ApproveForm.vue?vue&type=template&id=13639249&scoped=true"
import script from "./ApproveForm.vue?vue&type=script&lang=js"
export * from "./ApproveForm.vue?vue&type=script&lang=js"
import style0 from "./ApproveForm.vue?vue&type=style&index=0&id=13639249&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13639249",
  null
  
)

export default component.exports